<template>
  <div class="subscription-modal-component">
    <hi-dialog
      class="subscription-dialog"
      :title="$t('planSubscriptionPage.pageTitle')"
      @close="closeDialog"
      v-show="showSubscriptionModal"
    >
      <div class="payment-page">
        <div class="main-container">
          <div
            class="price-item"
            @click="switchPlan(cycle)"
            v-for="(cycle, index) in currentPlan.billingCycles"
            :class="{ select: form.id === cycle.id }"
            v-if="(filter === 'year' && index === 0) || filter === 'all'"
          >
            <div class="top-container">
              <div class="left-container">
                <div class="price-detail">
                  <div>{{ cycle.displayPrice }}</div>
                  <div v-if="index === 0" class="old-price-text">
                    {{ showCurrencyPrice(yearOldPrice) }}/{{
                      $t("myPlanPage.accountInfo.planNextTypeMonth")
                    }}
                  </div>
                  <div v-if="index === 0" class="most-popular">
                    {{ $t("planUpgradePage.mostPopular") }}
                  </div>
                </div>
                <div class="des">{{ cycle.desc }}</div>
              </div>
              <div v-show="form.id === cycle.id" class="icon"></div>
            </div>
            <div class="bottom-container" v-if="index === 0">
              <div class="des">
                {{ $t("planSubscriptionPage.saleEndTime") }}
              </div>
              <div class="item">
                <div class="num-text">0</div>
                <div class="time-des-text">
                  {{ $t("planSubscriptionPage.saleDays") }}
                </div>
              </div>
              <div class="item">
                <div class="num-text">{{ countTime.hours }}</div>
                <div class="time-des-text">
                  {{ $t("planSubscriptionPage.saleHours") }}
                </div>
              </div>
              <div class="item">
                <div class="num-text">{{ countTime.minutes }}</div>
                <div class="time-des-text">
                  {{ $t("planSubscriptionPage.saleMinutes") }}
                </div>
              </div>
              <div class="item">
                <div class="num-text">{{ countTime.seconds }}</div>
                <div class="time-des-text">
                  {{ $t("planSubscriptionPage.saleSeconds") }}
                </div>
              </div>
            </div>
          </div>
          <div class="price-tips" v-show="showPriceTip">
            {{ $t("planSubscriptionPage.priceTip") }}
          </div>
          <div class="automatic-tips">
            {{ $t("planSubscriptionPage.autoTip") }}
          </div>
          <div class="form-item" v-if="currentPayMethod === 0">
            <div class="title">
              {{ $t("planSubscriptionPage.stripContactTitle") }}
            </div>
            <div class="text-container">
              <input
                autocomplete="new-password"
                v-model="form.name"
                :placeholder="
                  $t('planSubscriptionPage.stripContactPlaceholder')
                "
              />
            </div>
          </div>
          <div class="form-item" v-if="currentPayMethod === 0">
            <div class="title">
              <div>{{ $t("planSubscriptionPage.stripCardTitle") }}</div>
              <div class="tips"></div>
            </div>
            <div class="text-container">
              <card
                style="width: 100%"
                :class="{ complete }"
                :stripe="stripe.publishableKey"
                :options="stripe.options"
                @change="complete = $event.complete"
              ></card>
            </div>
          </div>
          <div class="price-detail-list-container">
            <div class="item">
              <div class="title">
                {{ $t("planSubscriptionPage.planDetailNameTitle") }}
              </div>
              <div class="detail">{{ currentPlan.name }}</div>
            </div>
            <div class="item">
              <div class="title">
                {{ $t("planSubscriptionPage.planDetailPreMonthTitle") }}
              </div>
              <div class="detail">
                <template v-if="currentPlanCycle.interval > 1">
                  <label style="text-decoration: line-through">{{
                    this.currentPlan.billingCycles[1].pricePerMonth
                  }}</label>
                </template>
                {{ currentPlanCycle.pricePerMonth }}
              </div>
            </div>
            <div class="item">
              <div class="title">
                {{ $t("myPlanPage.accountInfo.planNextTypeMonth") }}
              </div>
              <div class="detail">
                {{ currentPlanCycle.interval }}
                <template v-if="currentPlanCycle.interval === 1"
                  >{{ $t("myPlanPage.accountInfo.planNextTypeMonth") }}
                </template>
                <template v-if="currentPlanCycle.interval > 1"
                  >{{ $t("myPlanPage.accountInfo.planNextTypeMonths") }}
                </template>
              </div>
            </div>
            <div class="item" v-if="hasDiscount">
              <div class="title">10% Discount for First {{ payTypeText }}</div>
              <div class="detail">-{{ discountPrice }}</div>
            </div>
            <div class="splice-line"></div>
            <div class="item total">
              <div class="title">
                {{ $t("planSubscriptionPage.planDetailTotalPriceTitle") }}
              </div>
              <div class="detail">{{ showCurrencyPrice(totalPrice) }}</div>
            </div>
          </div>
          <hi-button
            type="primary"
            :disabled="!subscriptionValidate"
            v-if="currentPayMethod === 0 || currentPayMethod === 1"
            @click="stripeClick"
            class="subscribe-btn"
            >{{ $t("planSubscriptionPage.stripBtn") }}
          </hi-button>
          <div class="subscribe-tips" v-if="currentPayMethod === 0">
            {{ $t("planSubscriptionPage.stripTip") }}
          </div>
          <div class="or-container" v-if="currentPayMethod === 0">
            <div class="line"></div>
            <div class="text">{{ $t("planSubscriptionPage.or") }}</div>
            <div class="line"></div>
          </div>
          <!-- <div class="pay-pal-container">
            <div class="des-text"
                 v-if="currentPayMethod===0">{{$t('planSubscriptionPage.payPalTip')}}</div>
            <hi-button type="primary"
                       v-if="currentPayMethod === 0 || currentPayMethod === 2"
                       @click="payPalClick"
                       class="pay-pal-btn">
              {{$t('planSubscriptionPage.payPalBtn')}}
            </hi-button>
          </div> -->
          <div class="pay-problem-btn" @click="payProblemClick">
            {{ $t("planSubscriptionPage.payError") }}
          </div>
        </div>
      </div>
    </hi-dialog>
    <paypal-comfirm
      v-model="showPaypalModal"
      :payType="payType"
      @subscribe="subscribeClick"
      :model="paypalConfirmInfo"
    ></paypal-comfirm>
    <el-dialog
      title="Confirm Downgrade?"
      :visible.sync="showDowngradeMenu"
      :modal="false"
      @close="downgradeCancelClick"
      width="400px"
    >
      <span>{{ downgradeText }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downgradeConfirmClick"
          >Confirm</el-button
        >
        <el-button @click="downgradeContactClick">{{
          $t("common.contactUs")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import hiDialog from "../../../common/dialog/Index.vue";
import HiButton from "../../../common/button/Index.vue";
import { Card } from "vue-stripe-elements-plus";
import { mapGetters } from "vuex";
import {
  CURRENT_USER_PLAN_LIST_SIMPLE,
  CURRENT_USER_INFO_SIMPLE,
  CURRENT_USER_PLAN_LIST,
  CURRENT_USER_INFO,
  PAYMENT_INFO,
} from "../../../../store/mutation-types";
import { stripePay, paypalUrl } from "../../../../service/payment";
import { showErrorMsg } from "../../../../utils/errors";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import paypalComfirm from "../../../payment/paypal_confirm/Index";

export default {
  name: "SubscriptionComponent",
  components: { Card, HiButton, paypalComfirm, hiDialog },
  mixins: [validationMixin],
  props: {
    planName: {
      // 选中的计划
      type: String,
      required: true,
    },
    billingCycleId: {
      // 计划对应价格
      type: Number,
      required: true,
    },
    filter: {
      default: "all",
    },
  },
  validations: {
    form: {
      name: {
        required,
      },
    },
  },
  data() {
    return {
      form: {
        id: "",
        name: "",
      },
      stripe: {
        publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
        options: {
          hidePostalCode: true,
        },
      },
      countTime: {
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
      payType: "stripe",
      complete: false,
      showSubscriptionModal: true, // 展示订阅弹窗
      showPaypalModal: false, // paypal支付弹出层
      showDowngradeMenu: false,
      downgradeText: "",
    };
  },
  computed: {
    ...mapGetters({
      planList: CURRENT_USER_PLAN_LIST_SIMPLE,
      user: CURRENT_USER_INFO_SIMPLE,
      planListOriginal: CURRENT_USER_PLAN_LIST,
      userOriginal: CURRENT_USER_INFO,
      paymentInfo: PAYMENT_INFO,
    }),
    /**
     *  判断订阅是否验证通过
     */
    subscriptionValidate() {
      // 如果上次支付方式是stripe paypal则直接通过验证
      if (this.currentPayMethod === 1 || this.currentPayMethod === 2) {
        return true;
      }
      if (this.form.name && this.complete) {
        return true;
      }
      return false;
    },
    /**
     * 2019.12.14 计算是否显示 “所有价格均为美元”
     */
    showPriceTip() {
      if (this.currentPlanCycle.currency === "USD") {
        return true;
      }
      // palpal支付判断是否是支持的国家，如果不支持或者本身是USD的则显示资源
      if (this.paymentMethod === 2) {
        return !this.currentPlanCycle.payPalSupportCurrency;
      } else {
        return false;
      }
    },
    /**
     * 计算paypal弹出信息
     */
    paypalConfirmInfo() {
      // 2019.12.14 防止出现paypal不支持的币种，所以读取和外层不同的字段
      const info = {
        planName: this.currentPlan.name,
        pricePerMonth: this.currentPlanCycle.pricePerMonth,
        interval: this.currentPlanCycle.interval,
        yearOldPrice: this.currentPlan.billingCycles[1].pricePerMonth,
        hasDiscount: this.hasDiscount,
        payTypeText: this.payTypeText,
        discountPrice: this.discountPrice,
        totalPrice: this.showCurrencyPrice(this.totalPrice),
        payPalSupportCurrency: this.currentPlanCycle.payPalSupportCurrency,
        currency: this.currentPlanCycle.currency,
      };
      // 如果不支持paypal则重新计算 部分字段
      if (
        this.payType === "paypal" &&
        !this.currentPlanCycle.payPalSupportCurrency
      ) {
        const price = this.currentPlanCycle.totalUsdPriceNum * this.discount;
        info.pricePerMonth = this.currentPlanCycle.paypalPrePrice;
        info.discountPrice = `${parseFloat(price.toPrecision(12))} ${
          this.currentPlanCycle.payPalCurrency
        }`;
        info.totalPrice = `${this.usdTotalPrice * (1 - this.discount)} ${
          this.currentPlanCycle.payPalCurrency
        }`;
      }
      return info;
    },
    /**
     * 获取支付方式
     */
    paymentMethod() {
      // 2018.11.5 新增通过url直接跳转支付页面，同时以payment_method作为支付方式最高优先级
      if (this.$route.query.payment_method !== undefined) {
        return Number(this.$route.query.payment_method);
      }
      return this.user.paymentMethod;
    },
    /**
     * 计算折扣比例
     */
    discount() {
      if (this.user.hasDiscount) {
        return 0.1;
      }
      return 0;
    },
    /**
     * 计算是否含有10%优惠
     */
    hasDiscount() {
      return this.user.hasDiscount;
    },
    /**
     * 计算当前选中付费项目的类型名称(年 or  月)
     */
    payTypeText() {
      const yearStr = this.$t("myPlanPage.accountInfo.planNextTypeYear");
      const monthStr = this.$t("myPlanPage.accountInfo.planNextTypeMonth");
      if (this.currentPlanCycle.interval === 12) {
        return yearStr;
      } else {
        return monthStr;
      }
    },
    /**
     * 计算10%所优惠价格
     */
    discountPrice() {
      const price = this.currentPlanCycle.totalPriceNum * 0.1;
      return this.showCurrencyPrice(parseFloat(price.toPrecision(12)));
    },
    /**
     * 由于存在邀请优惠所以当存在优惠时价格打9折
     */
    totalPrice() {
      let price = 0;
      if (this.hasDiscount) {
        price = this.currentPlanCycle.totalPriceNum * 0.9;
      } else {
        price = this.currentPlanCycle.totalPriceNum;
      }
      return parseFloat(price.toPrecision(12));
    },
    /**
     * 2019.12.14 美金的实际支付价格
     */
    usdTotalPrice() {
      const price =
        this.currentPlanCycle.totalUsdPriceNum * (1 - this.discount);
      return parseFloat(price.toPrecision(12));
    },
    /**
     * 年付优惠前价格
     */
    yearOldPrice() {
      const price = this.currentPlan.billingCycles[1].totalPriceNum;
      return parseFloat(price.toPrecision(12));
    },
    /**
     * 获取当前支付样式 0 全部 1 stripe 2 paypal
     */
    currentPayMethod() {
      console.log(this.user);
      const currentPlanIndex = this.planList.findIndex(
        (p) => p.name === this.user.plan.name
      );
      // 2021.8.25 当前订阅为vip 且vipPlan已被取消则走正常订阅
      const currentVipPlan =
        currentPlanIndex === -1 && this.user.plan.name === "VIP";
      if (currentVipPlan) {
        return 0;
      }
      if (this.paymentMethod === 4 || this.paymentMethod === 6) {
        return 0;
      }
      if (this.paymentMethod === 2 || this.paymentMethod === 3) {
        return 2;
      } else {
        return this.paymentMethod;
      }
    },
    /**
     * 获取当前计划
     */
    currentPlan() {
      const plan = this.planList.find((p) => p.name === this.planName);
      // 同时默认选中第一个
      return plan;
    },
    /**
     * 获取当前plan 选中cycle信息
     */
    currentPlanCycle() {
      return this.currentPlan.billingCycles.find(
        (bc) => bc.id === this.form.id
      );
    },
  },
  watch: {
    /**
     * 显示paypal展示监听
     */
    showPaypalModal(val) {
      this.showSubscriptionModal = !val;
    },
  },
  created() {
    this.form.id = this.billingCycleId;
    // 时间倒计时 保持倒计时时间介于30分钟到1小时之间
    setInterval(() => {
      // 获取当前时间
      const current = moment();
      // 加30分钟获取一个预估的截止时间
      let endTime = moment().add(30, "minutes");
      // 如果当前时间加30分钟还能保持时间小于30，则说明当前时间分钟大于30，这样只需要把预估截止时间分钟改成30就可以保证倒计时时间小于1小时,大于30分钟
      if (endTime.minutes() < 30) {
        endTime.minutes(30).second(0);
      } else {
        // 如果当前时间加30分钟还能保持时间大于30，则说明当前时间分钟小于30，这样只需要把预估截止时间分钟改成0小时+1就可以保证倒计时时间小于1小时,大于30分钟
        endTime.add(1, "h").minutes(0).second(0);
      }
      const diffMinutes = endTime.diff(current, "s");
      this.countTime.seconds = Number.parseInt(diffMinutes % 60);
      this.countTime.minutes = Number.parseInt(diffMinutes / 60);
    }, 1000);
  },
  methods: {
    /**
     * 2019.12.14 展示币种价格
     */
    showCurrencyPrice(value) {
      // 美金则把货币符号加载前面
      if (this.currentPlanCycle.currency === "USD") {
        return `$${value}`;
      } else {
        return `${value} ${this.currentPlanCycle.currency}`;
      }
    },
    /** 降级确认按钮点击事件 */
    async downgradeConfirmClick() {
      const loading = this.$loading();
      try {
        await stripePay(this.form);
        this.$toast.show({ message: this.$t("common.success") });
        this.closeDialog();
        this.showDowngradeMenu = false;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    /** 降级联系我们按钮点击事件 */
    async downgradeContactClick() {
      window.open(process.env.VUE_APP_CONTACT_US, "_blank");
      this.showDowngradeMenu = false;
      this.showSubscriptionModal = true;
    },
    async downgradeCancelClick() {
      this.showSubscriptionModal = true;
      this.showDowngradeMenu = false;
    },
    /**
     * 关闭dialog点击事件
     */
    closeDialog() {
      this.$parent.showSubscription = false;
    },
    async subscribeClick(type) {
      const loading = this.$loading();
      try {
        if (type === "paypal") {
          await this.paypalSubscribe();
        }
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
      if (type !== "paypal") {
        loading.close();
        await this.stripeSubscribe();
      }
    },
    /**
     * subscribe按钮点击事件
     */
    async stripeSubscribe() {
      // 如果发现是stripe订阅则验证是否为降级操作，如果是则弹出提示信息
      const activeIndex = this.planList.findIndex((i) => i.active);
      const currentPlanIndex = this.planList.findIndex(
        (p) => p.name === this.user.plan.name
      );
      // 2021.8.25 当前订阅为vip 且vipPlan已被取消则走正常订阅
      const currentVipPlan =
        currentPlanIndex === -1 && this.user.plan.name === "VIP";
      try {
        // 2021.8.25 特殊处理 vip正常订阅
        if (currentPlanIndex >= activeIndex || currentVipPlan) {
          const loading = this.$loading();
          await stripePay(this.form);
          loading.close();
          this.$toast.show({ message: this.$t("common.success") });
          this.closeDialog();
        } else {
          // 发现是降级操作，则直接弹出降级提示
          this.downgradeText = `You will be downgraded to “${
            this.planName
          } Plan” in your next payment period on ${moment(
            this.user.plan.currentPeriodEnd
          ).format("MMM DD, YYYY")}.`;
          this.showDowngradeMenu = true;
          this.showSubscriptionModal = false;
        }
      } catch (e) {
        showErrorMsg(e);
      }
    },
    /**
     * paypal弹出层点击确认回调
     */
    async paypalSubscribe() {
      const loading = this.$loading();
      try {
        // 2018.11.5 新增sale判断，如果是直接跳入该页面，则存在plan字段，sale为true，平时为false
        const url = await paypalUrl({
          id: this.form.id,
          sale: this.$route.query.plan_id !== undefined,
        });
        // 保存当前订阅类型
        this.$store.commit(PAYMENT_INFO, {
          planName: this.planName,
          billingCycleId: this.form.id,
          filter: this.filter,
        });
        // 隐藏弹出
        this.showPaypalModal = false;
        window.location.href = url;
      } catch (e) {
        showErrorMsg(e);
        loading.close();
      }
    },
    /**
     * PayPal按钮点击事件
     */
    async payPalClick() {
      this.showPaypalModal = true;
      this.payType = "paypal";
    },
    /**
     * stripe按钮点击事件
     */
    async stripeClick() {
      this.showPaypalModal = true;
      this.payType = "stripe";
    },
    /**
     * 切换付费计划
     * @param item 计划数据
     */
    switchPlan(item) {
      this.form.id = item.id;
    },
    /**
     * problem点击事件
     */
    payProblemClick() {
      window.open(process.env.VUE_APP_CONTACT_US, "_blank");
    },
  },
};
</script>

<style scoped lang="less">
@import "../../../../assets/style/theme.less";

.rtl .payment-page .main-container .price-item .top-container .most-popular {
  right: auto !important;
  left: 15px;
}

.subscription-modal-component {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 300;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  .subscription-dialog {
    width: 640px;
    height: 700px;
    /*overflow: hidden;*/
  }
}

.payment-page {
  flex: 1;
  overflow: auto;
  .main-container {
    padding: 15px 30px 60px 30px;
    /*max-height: 800px;*/
    /*overflow: auto;*/
    .price-item {
      border-radius: 4px;
      border: 2px solid @theme-color;
      margin-top: 14px;
      background: white;
      .top-container {
        display: flex;
        align-items: center;
        background: white;
        justify-content: space-between;
        color: @theme-color;
        position: relative;
        padding: 15px;
        width: 100%;
        .left-container {
          overflow-x: hidden;
          .price-detail {
            font-size: 18px;
            font-weight: 600;
            display: flex;
            align-items: center;
            .old-price-text {
              text-decoration: line-through;
              margin: 0 7px;
            }
            .most-popular {
              font-size: 13px;
              background: #f7e71b;
              border-radius: 2px;
              color: @theme-color;
              font-weight: bolder;
              height: 22px;
              padding: 0 15px;
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              right: 12px;
              top: -12px;
            }
          }
          .des {
            font-size: 12px;
            text-overflow: ellipsis;
            color: #000;
          }
        }
        .icon {
          width: 23px;
          height: 23px;
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
          background-image: url("../../../../../public/images/payment/White@3x.png");
        }
      }
      .bottom-container {
        min-height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        color: rgb(0, 0, 0);
        font-weight: 600;
        .des {
          font-size: 16px;
          color: @theme-color;
          display: flex;
          align-items: center;
          max-width: 140px;
          padding: 10px 0;
          line-height: 20px;
        }
        .item {
          text-align: center;
          line-height: 1;
          .num-text {
            font-size: 18px;
          }
          .time-des-text {
            font-weight: 500;
            font-size: 8px;
            margin-top: 2px;
          }
        }
      }
      &:first-child {
        margin-top: 0;
      }
      &.select .top-container {
        background: @theme-color;
        .des,
        .price-detail {
          color: white !important;
        }
      }
      &:active {
        opacity: 0.7;
      }
    }
    .price-tips {
      text-align: right;
      font-size: 12px;
      color: @font-color-gray;
      margin-top: 5px;
    }
    .automatic-tips {
      margin-top: 9px;
      font-size: 16px;
    }
    .form-item {
      .title {
        margin-top: 30px;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        position: relative;
        font-weight: 600;
        align-items: center;
        .tips {
          width: 91px;
          height: 20px;
          background-size: contain;
          background-repeat: no-repeat;
          background-image: url("../../../../../public/images/payment/powered_by_stripe@3x.png");
          background-position: center;
        }
      }
      .text-container {
        height: 44px;
        width: 100%;
        border: 1px solid @border-color;
        background: #f5f5f7;
        border-radius: 4px;
        margin-top: 20px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        input {
          border: 0;
          background: transparent;
          width: 100%;
          height: 100%;
          font-size: 16px;
        }
        input::placeholder {
          color: #d2d2d2;
        }
        .stripe-card {
          width: 100%;
        }
      }
    }
    .price-detail-list-container {
      font-size: 14px;
      border: 2px solid @theme-color;
      padding: 13px 15px;
      border-radius: 5px;
      margin-top: 12px;
      .item {
        display: flex;
        justify-content: space-between;
        height: 22px;
        line-height: 22px;
        margin-top: 5px;
        align-items: center;
        &:first-child {
          margin-top: 0;
        }
        &.total {
          font-weight: 600;
          margin-top: 0;
          .title {
            color: @theme-color;
            font-size: 16px;
          }
          .detail {
            font-size: 16px;
          }
        }
        .title {
          text-transform: capitalize;
        }
        .detail {
          color: @theme-color;
        }
      }
      .splice-line {
        border-top: 1px solid @border-color;
        height: 1px;
        margin: 10px 0;
      }
    }
  }
  .subscribe-btn {
    width: 100%;
    height: 44px;
    margin-top: 20px;
  }
  .subscribe-tips {
    font-size: 14px;
    color: #02c52c;
    text-align: center;
    margin-top: 10px;
  }
  .or-container {
    display: flex;
    align-items: center;
    margin-top: 18px;
    .line {
      flex: 1;
      height: 1px;
      background: @border-color;
    }
    .text {
      padding: 0 12px;
    }
  }
  .stripe-card {
    width: 100%;
    .complete {
      border-color: green;
    }
  }
  .pay-pal-container {
    .des-text {
      margin-top: 15px;
      text-align: center;
      font-size: 14px;
    }
    .pay-pal-btn {
      width: 100%;
      height: 44px;
      margin-top: 15px;
      background: #006fb9;
      font-weight: bolder;
      font-style: italic;
      &:active {
        opacity: 0.7;
        background: #006fb9;
      }
    }
  }
  .pay-problem-btn {
    font-size: 14px;
    color: #5a5a5a;
    margin-top: 9px;
    text-align: center;
    text-decoration: underline;
    cursor: pointer;
    &:active {
      opacity: 0.7;
    }
  }
}
</style>
